export default "__VITE_ASSET__BFJ2QFAQ__"